/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteComponentProps } from 'react-router-dom';

import BaseComponent from '@tock/shared/components/BaseComponent';
import LoginForm from 'forms/LoginForm';
import Panel from 'components/Panel';
import connect, { DefaultConnectProps } from 'utils/connect';

class LoginRoute extends BaseComponent<DefaultConnectProps & RouteComponentProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  handleLogin(formValues: any) {
    const { email, password } = formValues;

    this.setState({
      isLoading: true,
    });

    const success = () => {
      // Flag the redirect as a post-login navigation so SelectRoute keeps sending
      // non-eng users straight to /tock (explicit / navigation still shows Select app).
      this.props.history.push('/', { fromLogin: true });
    };

    const failure = () => {
      this.setState({
        isLoading: false,
      });
    };

    this.props.actions.app.authenticate(email, password).then(success).catch(failure);
  }

  render() {
    return (
      <Panel isLoading={this.state.isLoading} spinnerText="Loading clowncar...">
        <LoginForm onSubmit={this.handleLogin} />
      </Panel>
    );
  }
}

export default connect(LoginRoute);
